import { WebAssetResponse, AttachmentResponse } from "@akitabox/api-client";

import { getAssetFieldValue, formatDate, buildAssetHeader } from "./common";

export function singleImageWithDetails(
  asset: WebAssetResponse,
  attachment?: AttachmentResponse
) {
  return (
    <table className="ck-table-resized">
      <colgroup>
        <col style={{ width: "50%" }} />
        <col style={{ width: attachment ? "25%" : "50%" }} />
        {attachment && <col style={{ width: "25%" }} />}
      </colgroup>
      <tbody>
        {buildAssetHeader(asset, attachment ? 3 : 2)}
        {attachment ? (
          <tr>
            <td rowSpan={5}>
              <figure
                className="image image_resized image-style-align-center"
                style={{ width: "100%" }}
              >
                <img src={attachment.document.public_thumbnail_url_medium} />
                <figcaption>
                  {formatDate(
                    attachment.document.last_mod_date ||
                      attachment.document.cre_date
                  )}
                </figcaption>
              </figure>
            </td>
            <td>
              <span style={{ fontSize: "12px" }}>
                <strong>Category:</strong> <i>{asset.pinType.name}</i>
              </span>
            </td>
            <td>
              <span style={{ fontSize: "12px" }}>
                <strong>Size:</strong>{" "}
                <i>{getAssetFieldValue(asset, "Size")}</i>
              </span>
            </td>
          </tr>
        ) : (
          <tr>
            <td>
              <span style={{ fontSize: "12px" }}>
                <strong>Category:</strong> <i>{asset.pinType.name}</i>
              </span>
            </td>
            <td>
              <span style={{ fontSize: "12px" }}>
                <strong>Size:</strong>{" "}
                <i>{getAssetFieldValue(asset, "Size")}</i>
              </span>
            </td>
          </tr>
        )}
        <tr>
          <td>
            <span style={{ fontSize: "12px" }}>
              <strong>Type:</strong> <i>{getAssetFieldValue(asset, "Type")}</i>
            </span>
          </td>
          <td>
            <span style={{ fontSize: "12px" }}>
              <strong>Installation Date:</strong>{" "}
              <i>
                {getAssetFieldValue(asset, "Installation Date", formatDate)}
              </i>
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style={{ fontSize: "12px" }}>
              <strong>Manufacturer:</strong>{" "}
              <i>{getAssetFieldValue(asset, "Manufacturer")}</i>
            </span>
          </td>
          <td>
            <span style={{ fontSize: "12px" }}>
              <strong>Observed Remaining Life:</strong>{" "}
              <i>{getAssetFieldValue(asset, "Observed Remaining Life")}</i>
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style={{ fontSize: "12px" }}>
              <strong>Model:</strong>{" "}
              <i>{getAssetFieldValue(asset, "Model")}</i>
            </span>
          </td>
          <td>
            <span style={{ fontSize: "12px" }}>
              <strong>Condition:</strong>{" "}
              <i>{getAssetFieldValue(asset, "Condition")}</i>
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style={{ fontSize: "12px" }}>
              <strong>Serial Number:</strong>{" "}
              <i>{getAssetFieldValue(asset, "Serial Number")}</i>
            </span>
          </td>
          <td>
            <span style={{ fontSize: "12px" }}>
              <strong>Cost:</strong> <i>{asset.cost ? `$${asset.cost}` : ""}</i>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
